import axios from '@axios'

export default {
  listMural: pagina => axios.get(`${process.env.VUE_APP_WCOND_API}/avisos/${pagina}`),
  obterAviso: avisoId => axios.get(`${process.env.VUE_APP_WCOND_API}/aviso/${avisoId}`),
}
